import SvgIcon from '@mui/material/SvgIcon';

export default function MuiSVGIcon(props) {
  const { icon, ...rest } = props;
  return (
    <SvgIcon {...rest}>
      {icon}
    </SvgIcon>
  );
}